import { v4 as uuidv4 } from "uuid";
import { Vendor } from "./types";

export const getGuid = () => {
  return uuidv4();
};

export const reorderList = (list: string[], step: number): string[] => {
  const n = list.length;
  if (n === 0) return [];

  const offset = step % n;

  // Returnér altid et nyt array (immutabelt)
  return offset === 0
    ? [...list]
    : [...list.slice(-offset), ...list.slice(0, -offset)];
};

export function getSortedVendors(vendors: Vendor[], index: number): Vendor[] {
  if (!Array.isArray(vendors) || vendors.length === 0) {
    return [];
  }

  // Sørg for at index altid er gyldigt
  const safeIndex = Math.max(0, Math.min(index, vendors.length));

  // Split arrayet ved safeIndex
  const firstPart = vendors.slice(0, safeIndex);
  const secondPart = vendors.slice(safeIndex);

  // Byg det nye array
  return [...secondPart, ...firstPart];
}
